import { selectMatches } from "selectors/Match";
import { DriverPicksContainer } from "./styles";
import { PickemUserMatchemMatch } from "./PickemUserMatchemMatch";
import { PickemUserDriverPick } from "./PickemUserDriverPick";
import { getStringPick, Pickem } from "model/Pickem/Pickem";
import { FlexRow } from "styles/layout";
import { LeaderboardPart } from "model/Leaderboard/User/SegmentLeaderboardUser";
import { getDefinedRosterIds } from "model/Roster/Roster";
import { useAppSelector } from "app/hooks";
import { shallowEqual } from "react-redux";

interface Props {
  pickem: Pickem;
  tournamentId: string;
  leaderboardPart?: LeaderboardPart;
}

export const PickemUserMatchemPicks = ({
  pickem,
  tournamentId,
  leaderboardPart,
}: Props) => {
  const matchIds = Object.keys(pickem.picks);
  const matches = useAppSelector(
    (state) => selectMatches(state, matchIds),
    shallowEqual
  ).sort((a, b) => {
    if (a.startTimeMs === b.startTimeMs) {
      return a.id.localeCompare(b.id);
    }

    return a.startTimeMs - b.startTimeMs;
  });

  const driverIds = pickem?.driverPicks ?? [];

  return (
    <>
      <FlexRow>
        {matches.map((m) => (
          <PickemUserMatchemMatch
            key={m.id}
            rosterIds={getDefinedRosterIds(m.teams.rosters)}
            tournamentId={tournamentId}
            pickedRosterId={getStringPick(pickem.picks, m.id)}
            matchPoints={leaderboardPart?.points[m.id]}
          />
        ))}
      </FlexRow>

      {driverIds.length > 0 && (
        <DriverPicksContainer>
          {driverIds.map((driverId) => {
            return (
              <PickemUserDriverPick
                driverId={driverId}
                driverPoints={
                  !!leaderboardPart?.driverPoints
                    ? leaderboardPart.driverPoints[driverId]
                    : undefined
                }
                tournamentId={tournamentId}
              />
            );
          })}
        </DriverPicksContainer>
      )}
    </>
  );
};
